import React, { useState, useEffect } from 'react';
import { Box, Card, Avatar, Typography, Grid, Paper, Stack, Chip, LinearProgress, Divider, List, ListItem, ListItemIcon, ListItemText, Button, useTheme } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import CallIcon from '@mui/icons-material/Call';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PieChartIcon from '@mui/icons-material/PieChart';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useNavigate } from 'react-router-dom';
import { fetchDashboardStats, fetchServices, getCallLogs } from '../api';

// const notifications = [
//   { id: 1, text: '3 requests need review', icon: <NotificationsActiveIcon color="warning" /> },
//   { id: 2, text: '2 users pending approval', icon: <PersonIcon color="info" /> },
//   { id: 3, text: 'WhatsApp integration updated', icon: <CheckCircleIcon color="success" /> },
// ];
// const tipOfTheDay = "Did you know? You can quickly add a new user or service from the Quick Actions panel!";
// const stats = [
//   { label: 'Total Calls', value: 120, icon: <CallIcon fontSize="large" />, color: '#1976d2' },
//   { label: 'Total Requests', value: 80, icon: <AssignmentIcon fontSize="large" />, color: '#0288d1' },
//   { label: 'Closed', value: 50, icon: <CheckCircleIcon fontSize="large" />, color: '#2e7d32' },
//   { label: 'Open', value: 30, icon: <HourglassEmptyIcon fontSize="large" />, color: '#ed6c02' },
// ];


const fadeIn = {
  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'translateY(24px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  animation: 'fadeIn 1s cubic-bezier(0.4,0,0.2,1)'
};

function capitalizeFirstChar(str) {
  if (!str) return '';
  return str.replace(/\b\w/g, char => char.toUpperCase());
}

function DashboardPage() {
  const navigate = useNavigate();
  const userName = capitalizeFirstChar(localStorage.getItem('name'));
  const theme = useTheme();

  const [stats, setStats] = useState([
    { label: 'Total Calls', value: 0, icon: <CallIcon fontSize="large" />, color: '#1976d2' },
    { label: 'Total Requests', value: 0, icon: <AssignmentIcon fontSize="large" />, color: '#0288d1' },
    { label: 'Closed', value: 0, icon: <CheckCircleIcon fontSize="large" />, color: '#2e7d32' },
    { label: 'Open', value: 0, icon: <HourglassEmptyIcon fontSize="large" />, color: '#ed6c02' },
  ]);

  const [recent, setRecent] = useState([
    { id: 1, text: 'New call logged', icon: <CallIcon color="primary" /> },
    { id: 2, text: 'New service added: Second Opinion', icon: <AssignmentIcon color="info" /> },
    // { id: 3, text: 'Request pending for Dr. Kumar', icon: <HourglassEmptyIcon color="warning" /> },
  ]);
  
  const [open, setOpen] = useState(0);
  const [closed, setClosed] = useState(0);
  const [total, setTotal] = useState(0);
  // const [lastCalledPerson, setLastCalledPerson] = useState('');
  const [openPercent, setOpenPercent] = useState(0);
  const [closedPercent, setClosedPercent] = useState(0);
  // const [lastService, setLastService] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // fetch dashboard stats, services list and call logs
        const [dashboardData, servicesData, callsData] = await Promise.all([
          fetchDashboardStats(),
          fetchServices(),
          getCallLogs(),
        ]);

        const data = dashboardData;
        setStats([
          { label: 'Total Calls', value: data.totalCalls || 0, icon: <CallIcon fontSize="large" />, color: '#1976d2' },
          { label: 'Total Requests', value: data.totalRequests || 0, icon: <AssignmentIcon fontSize="large" />, color: '#0288d1' },
          { label: 'Closed', value: data.closedRequests || 0, icon: <CheckCircleIcon fontSize="large" />, color: '#2e7d32' },
          { label: 'Open', value: data.openRequests || 0, icon: <HourglassEmptyIcon fontSize="large" />, color: '#ed6c02' },
        ]);

        console.log(data);
        

        let lastServiceName = '';
        if (servicesData.success && servicesData.data.length > 0) {
          const last = servicesData.data[servicesData.data.length - 1];
          lastServiceName = last.TA_Service_Name;
          console.log(lastServiceName);
        }

        // Determine latest call from callsData. Response shape may vary: callsData may be an array or an object with .data
        let callsArray = [];
        if (Array.isArray(callsData)) {
          callsArray = callsData;
        } else if (callsData && Array.isArray(callsData.data)) {
          callsArray = callsData.data;
        } else if (callsData && callsData.data && Array.isArray(callsData.data.data)) {
          callsArray = callsData.data.data;
        }

        let latestCallerName = 'Unknown';
        if (callsArray.length > 0) {
          // find the latest call by available timestamp fields
          const sorted = callsArray.slice().sort((a, b) => {
            const dateA = new Date(a.TCLM_Call_Date || a.TCLM_Call_TimeStamp || a.createdAt || 0);
            const dateB = new Date(b.TCLM_Call_Date || b.TCLM_Call_TimeStamp || b.createdAt || 0);
            return dateB - dateA;
          });
          const latest = sorted[0] || {};
          latestCallerName = latest.TCLM_Caller_Name || latest.TCLM_Caller_Number || latest.callerName || 'Unknown';
        }

        setRecent([
          { id: 1, text: `New call logged ${latestCallerName}`, icon: <CallIcon color="primary" /> },
          { id: 2, text: `New request added: ${lastServiceName || 'None'}`, icon: <AssignmentIcon color="info" /> },
        ]);

        console.log(lastServiceName);
        console.log(callsArray);
        

        setOpen(data.openRequests || 0);
        setClosed(data.closedRequests || 0);
        const totalVal = (data.openRequests || 0) + (data.closedRequests || 0);
        setTotal(totalVal);
        setOpenPercent(totalVal ? ((data.openRequests || 0) / totalVal) * 100 : 0);
        setClosedPercent(totalVal ? ((data.closedRequests || 0) / totalVal) * 100 : 0);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        // minHeight: '100vh',
        height:'fit-content',
        // pb: 10,
        // border:'1px solid red',
        px: { xs: 0, sm: 2, md: 4 },
        // background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, #e3f2fd 100%)`,
        transition: 'background 0.5s',
      }}
    >
      {/* Welcome Banner */}
      <Card
        sx={{
          mb: 4,
          p: { xs: 2, sm: 3 },
          display: 'flex',
          alignItems: 'center',
          background: 'linear-gradient(135deg, rgb(49, 174, 190) 0%, #0088cc 100%)',
          color: '#fff',
          borderRadius: 3,
          boxShadow: 2,
          ...fadeIn,
        }}
      >
        <Avatar sx={{ bgcolor: '#fff', color: 'primary.main', width: 56, height: 56, mr: 2, boxShadow: 3, transition: 'transform 0.3s', '&:hover': { transform: 'scale(1.08)' } }}>
          <PersonIcon fontSize="large" />
        </Avatar>
        <Box flex={1}>
          <Typography variant="h6" fontWeight={700} sx={{ color: 'background.text',fontSize: { xs: '1.2rem',md:'1.5rem' }, }}>Welcome, {userName} !</Typography>
          {/* <Typography variant="body1">Hope you have a productive day.  <br/> Tip: {tipOfTheDay}</Typography> */}
        </Box>
      </Card>
      <Grid container spacing={3} mb={4}>
        {stats.map((stat, idx) => (
          <Grid item xs={12} sm={12} md={6} lg={3} key={idx}>
            <Paper
              elevation={4}
              sx={{
                p: 3,
                textAlign: 'center',
                borderRadius: 3,
                background: 'background.paper',
                boxShadow: `0 2px 12px 0 rgba(25, 118, 210, 0.08)`,
                opacity: 0,
                transform: 'translateY(32px)',
                animation: `fadeInStat 0.7s ${0.2 + idx * 0.15}s forwards`,
                '@keyframes fadeInStat': {
                  from: { opacity: 0, transform: 'translateY(32px)' },
                  to: { opacity: 1, transform: 'translateY(0)' },
                },
                transition: 'box-shadow 0.3s, transform 0.3s',
                '&:hover': {
                  boxShadow: 8,
                  transform: 'scale(1.04) translateY(-4px)',
                },
              }}
            >
              <Avatar sx={{ bgcolor: stat.color, width: { xs: 48, sm: 56 }, height: { xs: 48, sm: 56 }, mx: 'auto', mb: 1, boxShadow: 2, transition: 'transform 0.3s', '&:hover': { transform: 'scale(1.12)' } }}>
                {stat.icon}
              </Avatar>
              <Typography variant="subtitle1" color="text.secondary" sx={{ color: 'background.text' }}>{stat.label}</Typography>
              <Typography variant="h4" color="primary" fontWeight={700} >{stat.value}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
      {/* Request Status and Notifications */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} md={6}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderRadius: 3,
              height: 320,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'background.paper',
              boxShadow: 3,
              transition: 'box-shadow 0.3s, transform 0.3s',
              '&:hover': {
                boxShadow: 8,
                transform: 'scale(1.02)',
              },
              opacity: 0,
              animation: 'fadeInSection 0.8s 0.5s forwards',
              '@keyframes fadeInSection': {
                from: { opacity: 0, transform: 'translateY(32px)' },
                to: { opacity: 1, transform: 'translateY(0)' },
              },
            }}
          >
            <Typography variant="h6" mb={2} fontWeight={600} display="flex" alignItems="center" sx={{ color: 'background.text' }}><PieChartIcon sx={{ mr: 1, color: 'background.text' }} /> Request Status</Typography>
            <Stack direction="row" spacing={4} alignItems="center" justifyContent="center" width="100%">
              <Box textAlign="center">
                <Chip label="Open" color="warning" sx={{ fontWeight: 700, fontSize: 16, mb: 1, px: 2 }} />
                <Typography variant="h3" color="warning.main" fontWeight={700}>{open}</Typography>
              </Box>
              <Box textAlign="center">
                <Chip label="Closed" color="success" sx={{ fontWeight: 700, fontSize: 16, mb: 1, px: 2 }} />
                <Typography variant="h3" color="success.main" fontWeight={700}>{closed}</Typography>
              </Box>
            </Stack>
            {/* Graphical representation: horizontal bar */}
            <Box width="100%" mt={4}>
              <Box display="flex" alignItems="center" mb={1}>
                <Typography variant="body2" color="warning.main" fontWeight={700} minWidth={60}>Open</Typography>
                <LinearProgress
                  variant="determinate"
                  value={openPercent}
                  sx={{
                    flex: 1,
                    height: 14,
                    borderRadius: 7,
                    mx: 2,
                    bgcolor: '#ffe0b2',
                    '& .MuiLinearProgress-bar': {
                      bgcolor: '#ed6c02',
                      transition: 'width 1s cubic-bezier(0.4,0,0.2,1)',
                    },
                    transition: 'background 0.5s',
                  }}
                />
                <Typography variant="body2" color="background.text" fontWeight={700}>{openPercent.toFixed(0)}%</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography variant="body2" color="success.main" fontWeight={700} minWidth={60}>Closed</Typography>
                <LinearProgress
                  variant="determinate"
                  value={closedPercent}
                  sx={{
                    flex: 1,
                    height: 14,
                    borderRadius: 7,
                    mx: 2,
                    bgcolor: '#c8e6c9',
                    '& .MuiLinearProgress-bar': {
                      bgcolor: '#2e7d32',
                      transition: 'width 1s cubic-bezier(0.4,0,0.2,1)',
                    },
                    transition: 'background 0.5s',
                  }}
                />
                <Typography variant="body2" color="background.text" fontWeight={700} >{closedPercent.toFixed(0)}%</Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
        {/* Quick Actions and Recent Activity */}
        <Grid item xs={12} md={6}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderRadius: 3,
              height: 'fit-content',
              background: 'background.paper',
              boxShadow: 3,
              transition: 'box-shadow 0.3s, transform 0.3s',
              '&:hover': {
                boxShadow: 8,
                transform: 'scale(1.02)',
              },
              opacity: 0,
              animation: 'fadeInSection 0.8s 0.9s forwards',
              '@keyframes fadeInSection': {
                from: { opacity: 0, transform: 'translateY(32px)' },
                to: { opacity: 1, transform: 'translateY(0)' },
              },
            }}
          >
            <Typography variant="h6" mb={2} fontWeight={600} sx={{ color: 'background.text' }}>Quick Actions</Typography>
            <Stack
                direction={{ xs: 'column', sm: 'row',md:'column',xl:'row' }}
                spacing={2.5}
                sx={{ width: '100%' }}
              >
                {[
                  { label: 'Add Interactions', path: '/interactions-new', color: 'primary' },
                  { label: 'Add User', path: '/user', color: 'warning' },
                  { label: 'Add Service', path: '/roles-services', color: 'secondary' },
                  { label: 'Add Role', path: '/roles-services', color: 'success' },
                  { label: 'Add PRO', path: '/pro-master', color: 'primary' },
                ].map((btn, idx) => (
                  <Button
                    key={idx}
                    fullWidth
                    variant="contained"
                    onClick={() => {
                      window.scrollTo(0, 0); // quick fix
                      navigate(btn.path);
                    }}
                    color={btn.color}
                    size="medium"
                    startIcon={<AddCircleIcon />}
                    sx={{
                      borderRadius: 3,
                      fontWeight: 700,
                      textTransform: 'none',
                      fontSize:{ xs:14,sm:10,md:10,lg:14 },
                      px: 3,
                      color: 'white',
                      transition: 'box-shadow 0.3s, transform 0.3s',
                      '&:hover': {
                        boxShadow: 6,
                        transform: 'scale(1.06)',
                      },
                    }}
                  >
                    {btn.label}
                  </Button>
                ))}
              </Stack>
          </Paper>
          <Box mt={3} />
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderRadius: 3,
              height: 'fit-content',
              background: 'background.paper',
              boxShadow: 3,
              transition: 'box-shadow 0.3s, transform 0.3s',
              '&:hover': {
                boxShadow: 8,
                transform: 'scale(1.02)',
              },
              opacity: 0,
              animation: 'fadeInSection 0.8s 1.1s forwards',
              '@keyframes fadeInSection': {
                from: { opacity: 0, transform: 'translateY(32px)' },
                to: { opacity: 1, transform: 'translateY(0)' },
              },
            }}
          >
            <Typography variant="h6" mb={2} fontWeight={600} sx={{ color: 'background.text' }}>Recent Activity</Typography>
            <List>
              {recent.map((item, idx) => (
                <ListItem key={item.id} sx={{ opacity: 0, animation: `fadeInNotif 0.7s ${1.1 + idx * 0.15}s forwards`, '@keyframes fadeInNotif': { from: { opacity: 0, transform: 'translateY(16px)' }, to: { opacity: 1, transform: 'translateY(0)' } } }}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} sx={{ color: 'background.text' }} />
                </ListItem>
              ))}
            </List>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body2" color="background.text">Stay on top of your tasks for a smooth workflow!</Typography>
          </Paper>
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderRadius: 3,
              height: 320,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              background: 'background.paper',
              boxShadow: 3,
              transition: 'box-shadow 0.3s, transform 0.3s',
              '&:hover': {
                boxShadow: 8,
                transform: 'scale(1.02)',
              },
              opacity: 0,
              animation: 'fadeInSection 0.8s 0.7s forwards',
              '@keyframes fadeInSection': {
                from: { opacity: 0, transform: 'translateY(32px)' },
                to: { opacity: 1, transform: 'translateY(0)' },
              },
            }}
          >
            <Typography variant="h6" mb={2} fontWeight={600} display="flex" alignItems="center" sx={{color:'background.text'}}><NotificationsActiveIcon sx={{mr:1}}/> Notifications & Tasks</Typography>
            <List>
              {notifications.map((item, idx) => (
                <ListItem key={item.id} sx={{ opacity: 0, animation: `fadeInNotif 0.7s ${0.5 + idx * 0.15}s forwards`, '@keyframes fadeInNotif': { from: { opacity: 0, transform: 'translateY(16px)' }, to: { opacity: 1, transform: 'translateY(0)' } } }}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} sx={{color:'background.text'}} />
                </ListItem>
              ))}
            </List>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body2" color="background.text">Stay on top of your tasks for a smooth workflow!</Typography>
          </Paper>
        </Grid> */}
      </Grid>
      {/* <Grid container spacing={3} mb={4}>
      </Grid> */}
    </Box>
  );
}

export default DashboardPage; 